import { CommonSearchParam, ApiBind } from './common-search-param.model';

export class DesignTemplateSearchParam extends CommonSearchParam {

  constructor(
    type: string,
    name?: string,
    passback?: string,
    passbackId?: number,
    passbackOnly?: boolean,
    adFormat?: number[],
    designTemplateType?: number[],
    multiAdHtml?: string,
    multiAdHtmlOnly?: boolean,
  ) {
    super();
    this.type = type;
    this.name = name;
    this.passback = passback;
    this.passbackId = passbackId;
    this.passbackOnly = passbackOnly;
    if (!passbackOnly) {
      this.adFormat = adFormat;
    }
    this.designTemplateType = designTemplateType;
    this.multiAdHtml = multiAdHtml;
    this.multiAdHtmlOnly = multiAdHtmlOnly;
  }

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'type' })
  type: string;

  @ApiBind({ column: 'passback' })
  passback: string;

  @ApiBind({ column: 'passback_id' })
  passbackId: number;

  @ApiBind({ column: 'passback_only' })
  passbackOnly: boolean;

  @ApiBind({ column: 'ad_format' })
  adFormat: number[];

  @ApiBind({ column: 'design_template_type' })
  designTemplateType: number[];

  @ApiBind({ column: 'multi_ad_html' })
  multiAdHtml: string;

  @ApiBind({ column: 'multi_ad_html_only' })
  multiAdHtmlOnly: boolean;

}
